@import '../../../../ui/gzDialog/view/windowShared.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.footer__container {
  @include windowFooter;

  margin-top: auto;
  justify-content: space-between;
}
